export const determineCanonical = (path) =>
  `${process.env.URL || 'http://localhost:8000'}${path}`;
